import React, { useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';

const useSize = (target) => {
  const [size, setSize] = useState();
  React.useLayoutEffect(() => {
    setSize(target.current?.getBoundingClientRect());
  }, [target.current?.id]);

  useResizeObserver(target, (entry) => setSize(entry.contentRect));
  return size;
};

export default useSize;
